const numToFixed = (data) => {
    return Number(data).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

const numToFixed2 = (data) => {
    let subNum = Number(data).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    let lengthNum = subNum.length
    subNum = subNum.substring(0, lengthNum-3)
    return subNum
}

const numAddZero = (data) => {
    if (data < 10) {
        return '0' + data.toString()
    }
    return data.toString()
}

export default numToFixed
export { numAddZero, numToFixed2 }